"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Base_1 = __importDefault(require("./Base"));
var Dashboards_1 = __importDefault(require("./Dashboards"));
var firebase_1 = require("./firebase");
var Widget = /** @class */ (function (_super) {
    __extends(Widget, _super);
    function Widget(orgId, dasahboardId, widgetId) {
        var _this = _super.call(this, widgetId) || this;
        _this.getDashboard = function () { return _this.dashboard; };
        _this.getDashboardId = function () { return _this.dashboardId; };
        _this.path = function () {
            return "/dashboards/" + _this.orgId + "/" + _this.dashboardId + "/widgets/" + _this.id;
        };
        _this.get = function () {
            return _this.getByPath(_this.path());
        };
        _this.delete = function () {
            return _this.deleteByPath(_this.path());
        };
        _this.getIdsForUser = function (uid) {
            return _this.getByPath("/users_mapping/widgets/" + uid);
        };
        _this.getConfig = function (orgId) {
            return _this.getByPath("/widgets_config/" + orgId);
        };
        _this.getRequest = function () {
            return _this.getByPath(_this.path() + "/request");
        };
        _this.getResult = function () {
            return _this.getByPath(_this.path() + "/result");
        };
        _this.refreshWidget = function (widgetRequest) {
            widgetRequest.requestedAt = firebase_1.dbConstants.ServerValue.TIMESTAMP;
            return _this.update(_this.path() + "/request", widgetRequest);
        };
        _this.dashboard = new Dashboards_1.default(orgId);
        _this.orgId = orgId;
        _this.dashboardId = dasahboardId;
        return _this;
    }
    return Widget;
}(Base_1.default));
exports.default = Widget;
//# sourceMappingURL=Widget.js.map


//////////////////
// WEBPACK FOOTER
// ../api/lib/data/Widget.js
// module id = 1540
// module chunks = 8